import React, { createContext, type ReactNode, useContext, useMemo } from 'react';
import { useSelector } from 'react-redux';

import type { RootState } from '@app/store/rootDuck';

export type CustomersType = 'default' | 'dms';

interface CustomersContextValue {
    formType: CustomersType;
    isDmsActive: boolean;
}

const CustomersContext = createContext<CustomersContextValue | undefined>(undefined);

interface CustomersProviderProps {
    children: ReactNode;
}

export const CustomersProvider: React.FC<CustomersProviderProps> = ({ children }) => {
    const { userData } = useSelector((state: RootState) => state.auth);
    const isDmsActive = !!userData?.is_dms_active;

    const value: CustomersContextValue = useMemo(
        () => ({
            formType: isDmsActive ? 'dms' : 'default',
            isDmsActive,
        }),
        [isDmsActive],
    );

    return <CustomersContext.Provider value={value}>{children}</CustomersContext.Provider>;
};

export const useCustomersContext = (): CustomersContextValue => {
    const context = useContext(CustomersContext);
    if (context === undefined) {
        throw new Error('useCustomersContext must be used within a CustomersProvider');
    }
    return context;
};
